import React, { useState } from "react";
import { Grid, IconButton, Tooltip, Typography, Divider } from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices"; // 🧹 Clear icon

const WarehouseEnvironmentActionMenu = ({
  isEdit,
  onSave,
  onDelete,
  onClear, // ✅ added
  onExit,
  saveDisabled,
}) => {
  const [selectedButton, setSelectedButton] = useState(null);

  const handleClick = (btn) => {
    setSelectedButton(btn);
    switch (btn) {
      case "save":
        onSave && onSave();
        break;
      case "clear":
        onClear && onClear();
        break;
      case "delete":
        onDelete && onDelete();
        break;
      case "exit":
        onExit && onExit();
        break;
      default:
        break;
    }
  };

  return (
    <Grid container justifyContent="space-between" alignItems="center" padding={0}>
      {/* Left-aligned Title */}
      <Grid item>
        <Typography
          variant="h4"
          sx={{
            textAlign: "center",
            width: "100%",
            marginLeft: "10px",
            alignItems: "center",
          }}
        >
          {isEdit ? "Edit Environment Type" : "New Environment Type Entry"}
        </Typography>
      </Grid>

      {/* Right-aligned Buttons */}
      <Grid item>
        <Grid container alignItems="center">
          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* Save */}
          <Grid item ml={1} mr={1}>
            <Tooltip title="Save">
              <IconButton
                onClick={() => handleClick("save")}
                sx={{ display: "flex", alignItems: "center" }}
                disabled={saveDisabled}
              >
                <SaveAltIcon
                  style={{
                    fontSize: "18px",
                    color: selectedButton === "save" ? "yellow" : "#009688",
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{ ml: 1, fontSize: "0.875rem", color: "#fff" }}
                >
                  Save
                </Typography>
              </IconButton>
            </Tooltip>
          </Grid>

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* ✅ Clear */}
          <Grid item ml={1} mr={1}>
            <Tooltip title="Clear">
              <IconButton
                onClick={() => handleClick("clear")}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <CleaningServicesIcon
                  style={{
                    fontSize: "18px",
                    color: selectedButton === "clear" ? "yellow" : "#ffb300",
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{ ml: 1, fontSize: "0.875rem", color: "#fff" }}
                >
                  Clear
                </Typography>
              </IconButton>
            </Tooltip>
          </Grid>

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* Delete (only if edit mode) */}
          {isEdit && (
            <>
              <Grid item ml={1} mr={1}>
                <Tooltip title="Delete">
                  <IconButton
                    onClick={() => handleClick("delete")}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <DeleteIcon
                      style={{
                        fontSize: "18px",
                        color: selectedButton === "delete" ? "yellow" : "#f44336",
                      }}
                    />
                    <Typography
                      variant="body2"
                      sx={{ ml: 1, fontSize: "0.875rem", color: "#fff" }}
                    >
                      Delete
                    </Typography>
                  </IconButton>
                </Tooltip>
              </Grid>
              <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
            </>
          )}

          {/* Exit */}
          <Grid item ml={1} mr={1}>
            <Tooltip title="Exit">
              <IconButton
                onClick={() => handleClick("exit")}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <CloseIcon
                  style={{
                    fontSize: "18px",
                    color: selectedButton === "exit" ? "yellow" : "#2196F3",
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{ ml: 1, fontSize: "0.875rem", color: "#fff" }}
                >
                  {/* Exit */}
                </Typography>
              </IconButton>
            </Tooltip>
          </Grid>

          <Divider orientation="vertical" flexItem />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default WarehouseEnvironmentActionMenu;
